export const sportTypeMap = {
    "pickleball": "courts",
    "badminton": "courts",
    "football": "grounds",
    "box-cricket": "venues"
  };

  export const sportsList = [
    { key: "pickleball", label: "Pickleball Courts" },
    { key: "football", label: "Football Grounds" },
    { key: "badminton", label: "Badminton Courts" },
    { key: "box-cricket", label: "Box Cricket Venues" }
  ];

  